'use client';

import { NOTIFICATION_CONFIGURATIONS } from 'src/constants/constants';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

const useNotificationPlacementSetting = () =>
	useSyncLocalStorage<string>(
		'notificationPlacement',
		NOTIFICATION_CONFIGURATIONS[0].value
	);

export default useNotificationPlacementSetting;
